import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import { tokenExpired } from '@/helpers/authHelper'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/companies',
    name: 'companies.index',
    component: () => import('@/views/Companies/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/production_lines',
    name: 'production_lines.index',
    component: () => import('@/views/ProductionLines/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/production_lines/:id',
    name: 'phases.index',
    component: () => import('@/views/Phases/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventories',
    name: 'inventories.index',
    component: () => import('@/views/Inventories/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventories/:id',
    name: 'batches.index',
    component: () => import('@/views/Batches/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/products',
    name: 'products.index',
    component: () => import('@/views/Products/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/jobs',
    name: 'jobs.index',
    component: () => import('@/views/Jobs/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/jobs/:id',
    name: 'jobs.show',
    component: () => import('@/views/Jobs/Show.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/fields',
    name: 'fields.index',
    component: () => import('@/views/Fields/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/clients',
    name: 'clients.index',
    component: () => import('@/views/Clients/Index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/clients/:id/edit',
    name: 'clients.edit',
    component: () => import('@/views/Clients/Edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (tokenExpired()) {
      next({ name: 'login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router
